import {
  addListener,
  createAsyncThunk,
  createListenerMiddleware,
  createSelector,
  TypedStartListening,
} from '@reduxjs/toolkit'
import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from 'react-redux'

import { NormalStatus } from '@/constants/normal-status'
import { Group } from '@/model/group'

import type {
  AppDispatch,
  RootState,
} from './index'

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;
export type AppSelector = TypedUseSelectorHook<RootState>;
export const useAppDispatch: () => AppDispatch = useDispatch
export const appListener = createListenerMiddleware()

export const startAppListening = appListener.startListening.withTypes<
  RootState,
  AppDispatch
>()
export const addAppListener = addListener.withTypes<RootState, AppDispatch>()
export const useAppSelector: AppSelector = useSelector
export const createAppSelector = createSelector.withTypes<RootState>()
export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
}>()

export const optionsInGroupCombiner = (
  dataSource: { status: NormalStatus, groupId: number, id: number, name: string }[],
  groups: Group[],
) => dataSource
  .map(({ id, name, status, groupId }) => {
    const group = groups.find(({ id }) => id === groupId)
    return {
      value: id,
      label: name,
      status,
      groupIds: [...(group?.ancestorIds || []), groupId],
    }
  })
